import { Header } from './Header.jsx'
import { Main } from './Main.jsx'
import { Footer } from './Footer.jsx'

export function Home() {
    return (
        <>
            <Header />
            <Main />
            <Footer />
        </>
    )
}
